export default {

    copy: function(value) {
    
        return JSON.parse(JSON.stringify(value))
    
    }

}